/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GenericResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { GiornoDellaSettimanaEnum } from '../model/models';
import { ServizioMensaAllineaScuoleDTO } from '../model/models';
import { ServizioMensaCalendarioScolasticoDTO } from '../model/models';
import { ServizioMensaCalendarioScolasticoForm } from '../model/models';
import { ServizioMensaChiusuraScolasticaDTO } from '../model/models';
import { ServizioMensaChiusuraScolasticaForm } from '../model/models';
import { ServizioMensaChiusuraScolasticaUpdateForm } from '../model/models';
import { ServizioMensaChiusureScolasticheBulkForm } from '../model/models';
import { ServizioMensaChiusureSettimanaliForm } from '../model/models';
import { ServizioMensaPastiDipendentiDTO } from '../model/models';
import { ServizioMensaPastiDipendentiUpsertForm } from '../model/models';
import { ServizioMensaScuolaDTO } from '../model/models';
import { ServizioMensaSezioneClasseDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface AddServizioMensaScuolaCalendarioScolasticoRequestParams {
    idScuola: string;
    gestioneMenseServizioId: string;
    servizioMensaCalendarioScolasticoForm: ServizioMensaCalendarioScolasticoForm;
}

export interface AddServizioMensaScuolaChiusuraScolasticaRequestParams {
    idScuola: string;
    gestioneMenseServizioId: string;
    servizioMensaChiusuraScolasticaForm: ServizioMensaChiusuraScolasticaForm;
}

export interface AddServizioMensaScuoleChiusureScolasticheRequestParams {
    gestioneMenseServizioId: string;
    servizioMensaChiusureScolasticheBulkForm: ServizioMensaChiusureScolasticheBulkForm;
}

export interface AllineaServizioMensaScuoleDaBandoRequestParams {
    gestioneMenseServizioId: string;
}

export interface ClonaServizioMensaScuolaCalendarioScolasticoRequestParams {
    idScuola: string;
    idScuolaDaClonare: string;
    gestioneMenseServizioId: string;
    forced?: boolean;
}

export interface EditServizioMensaScuolaCalendarioScolasticoRequestParams {
    idScuola: string;
    gestioneMenseServizioId: string;
    servizioMensaCalendarioScolasticoForm: ServizioMensaCalendarioScolasticoForm;
}

export interface EditServizioMensaScuolaChiusuraScolasticaRequestParams {
    idScuola: string;
    idChiusuraScolastica: string;
    gestioneMenseServizioId: string;
    servizioMensaChiusuraScolasticaUpdateForm: ServizioMensaChiusuraScolasticaUpdateForm;
}

export interface GetServizioMensaScuolaCalendarioScolasticoRequestParams {
    idScuola: string;
    gestioneMenseServizioId: string;
}

export interface GetServizioMensaScuolaPastiDipendentiRequestParams {
    idScuola: string;
    gestioneMenseServizioId: string;
}

export interface GetServizioMensaScuolaSezioniClassiRequestParams {
    idScuola: string;
    gestioneMenseServizioId: string;
}

export interface ListServizioMensaScuoleRequestParams {
    gestioneMenseServizioId: string;
}

export interface RemoveServizioMensaScuolaChiusuraScolasticaRequestParams {
    idScuola: string;
    idChiusuraScolastica: string;
    gestioneMenseServizioId: string;
}

export interface ReplaceServizioMensaScuolaChiusureSettimanaliRequestParams {
    idScuola: string;
    gestioneMenseServizioId: string;
    servizioMensaChiusureSettimanaliForm: ServizioMensaChiusureSettimanaliForm;
}

export interface SetServizioMensaScuolaNumeroMinimoPastiDaFatturareRequestParams {
    idScuola: string;
    gestioneMenseServizioId: string;
    numeroMinimoPastiDaFatturare?: number;
}

export interface SetServizioMensaScuolaPastiDipendentiRequestParams {
    idScuola: string;
    gestioneMenseServizioId: string;
    servizioMensaPastiDipendentiUpsertForm: ServizioMensaPastiDipendentiUpsertForm;
}


export interface ServizioMensaScuoleServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Crea il calendario scolastico reference di una scuola del servizio mensa.
     * Crea il calendario 1:1 con data inizio/fine (dd/MM/yyyy). Calendario già esistente → 400; data_fine precedente a data_inizio → 400. Nessun seed automatico dalle date del servizio. Audience ADMIN/SUPERADMIN/OP_SCUOLA/OP_COMUNE.
     * @endpoint post /api/v1/servizi/mensa/scuole/{id_scuola}/calendario-scolastico
* @param requestParameters
     */
    addServizioMensaScuolaCalendarioScolastico(requestParameters: AddServizioMensaScuolaCalendarioScolasticoRequestParams, extraHttpRequestParams?: any): Observable<ServizioMensaCalendarioScolasticoDTO>;

    /**
     * Crea chiusure scolastiche puntuali (range espanso per-giorno).
     * Accetta un range data_inizio/data_fine (+ classe/sezione/motivazione opzionali) e lo espande in una riga per giorno, saltando i giorni in chiusura settimanale. In alternativa a classe/sezione, la lista classi chiude più classi in una sola richiesta, all-or-nothing (classi + classe/sezione, lista vuota o voce vuota → 400). Range fuori finestra calendario → 400; collisione stessa data+scope → 400; nessun gate anti-passato (la retroattività innesca il ricalcolo derivato). Audience ADMIN/SUPERADMIN/OP_SCUOLA/OP_COMUNE.
     * @endpoint post /api/v1/servizi/mensa/scuole/{id_scuola}/chiusura-scolastica
* @param requestParameters
     */
    addServizioMensaScuolaChiusuraScolastica(requestParameters: AddServizioMensaScuolaChiusuraScolasticaRequestParams, extraHttpRequestParams?: any): Observable<Array<ServizioMensaChiusuraScolasticaDTO>>;

    /**
     * Crea chiusure scolastiche in blocco sulle scuole del servizio.
     * Stesso payload del POST singolo + scuole_ids opzionale (assente → tutte le scuole del servizio; presente → subset validato within-servizio, id estraneo → 404). All-or-nothing: una collisione o una scuola senza calendario fa fallire l\&#39;intero bulk, col nome della scuola colpita. Erede di POST /api/v1/scuola/chiusura-scolastica-for-all, riscopato dal cross-comune al servizio. Audience ADMIN/SUPERADMIN/OP_SCUOLA/OP_COMUNE.
     * @endpoint post /api/v1/servizi/mensa/scuole/chiusure-scolastiche
* @param requestParameters
     */
    addServizioMensaScuoleChiusureScolastiche(requestParameters: AddServizioMensaScuoleChiusureScolasticheRequestParams, extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

    /**
     * Allinea le scuole del servizio ai plessi attivi del bando.
     * Materializza le ServizioMensaScuola mancanti per i plessi L2 attivi del bando associato al servizio header. Idempotente: le scuole già presenti non vengono duplicate né modificate, e le scuole di plessi poi disattivati NON vengono rimosse (conservano studenti, calendario e pasti configurati). Serve a recuperare i bandi rimasti disallineati, quando i plessi erano stati aggiunti prima che la materializzazione per-plesso esistesse. Ritorna i conteggi: scuole_create&#x3D;0 con plessi_attivi&gt;0 significa che era già tutto allineato. Audience ADMIN/SUPERADMIN/OP_COMUNE.
     * @endpoint post /api/v1/servizi/mensa/scuole/allinea-da-bando
* @param requestParameters
     */
    allineaServizioMensaScuoleDaBando(requestParameters: AllineaServizioMensaScuoleDaBandoRequestParams, extraHttpRequestParams?: any): Observable<ServizioMensaAllineaScuoleDTO>;

    /**
     * Clona il calendario scolastico da un\&#39;altra scuola dello stesso servizio.
     * Copia bound + chiusure puntuali + chiusure settimanali dalla scuola sorgente (anti-IDOR: sorgente di altro servizio → 404). Con calendario destinazione esistente serve forced&#x3D;true (replace con orphanRemoval); su replace forced i giorni passati riclassificati innescano il ricalcolo derivato conservativo. Audience ADMIN/SUPERADMIN/OP_SCUOLA/OP_COMUNE.
     * @endpoint put /api/v1/servizi/mensa/scuole/{id_scuola}/calendario-scolastico/clona
* @param requestParameters
     */
    clonaServizioMensaScuolaCalendarioScolastico(requestParameters: ClonaServizioMensaScuolaCalendarioScolasticoRequestParams, extraHttpRequestParams?: any): Observable<ServizioMensaCalendarioScolasticoDTO>;

    /**
     * Aggiorna le date del calendario scolastico di una scuola del servizio mensa.
     * Aggiorna data inizio/fine. Nuovo range che esclude chiusure puntuali esistenti → 400 dedicato. I giorni riclassificati passati innescano il ricalcolo derivato (storico, portafogli, rendicontazione) nella stessa transazione. Audience ADMIN/SUPERADMIN/OP_SCUOLA/OP_COMUNE.
     * @endpoint put /api/v1/servizi/mensa/scuole/{id_scuola}/calendario-scolastico
* @param requestParameters
     */
    editServizioMensaScuolaCalendarioScolastico(requestParameters: EditServizioMensaScuolaCalendarioScolasticoRequestParams, extraHttpRequestParams?: any): Observable<ServizioMensaCalendarioScolasticoDTO>;

    /**
     * Modifica una singola riga di chiusura scolastica puntuale.
     * Edita data, scope classe/sezione e motivazione della riga per-giorno (cambio contratto vs il legacy a range). Data fuori finestra → 400; collisione → 400. Su riclassificazione passata il ricalcolo gira sull\&#39;unione delle coorti vecchio+nuovo scope. Audience ADMIN/SUPERADMIN/OP_SCUOLA/OP_COMUNE.
     * @endpoint put /api/v1/servizi/mensa/scuole/{id_scuola}/chiusura-scolastica/{id_chiusura_scolastica}
* @param requestParameters
     */
    editServizioMensaScuolaChiusuraScolastica(requestParameters: EditServizioMensaScuolaChiusuraScolasticaRequestParams, extraHttpRequestParams?: any): Observable<ServizioMensaChiusuraScolasticaDTO>;

    /**
     * Vista completa del calendario scolastico di una scuola del servizio mensa.
     * Bound + TUTTE le chiusure puntuali (con scope classe/sezione e motivazione) + chiusure settimanali — gemello operatore non filtrato del calendario-mensa cittadino. Calendario assente → 404. Audience ADMIN/SUPERADMIN/OP_SCUOLA/OP_COMUNE.
     * @endpoint get /api/v1/servizi/mensa/scuole/{id_scuola}/calendario-scolastico
* @param requestParameters
     */
    getServizioMensaScuolaCalendarioScolastico(requestParameters: GetServizioMensaScuolaCalendarioScolasticoRequestParams, extraHttpRequestParams?: any): Observable<ServizioMensaCalendarioScolasticoDTO>;

    /**
     * Legge la configurazione pasti dipendenti di una scuola del servizio mensa.
     * Ritorna i totali per-categoria e i menu non ordinari della scuola indicata, scopata dall\&#39;header Gestione-Mense-Servizio-Id. Audience ADMIN/SUPERADMIN/OP_SCUOLA/OP_COMUNE.
     * @endpoint get /api/v1/servizi/mensa/scuole/{id_scuola}/pasti-dipendenti
* @param requestParameters
     */
    getServizioMensaScuolaPastiDipendenti(requestParameters: GetServizioMensaScuolaPastiDipendentiRequestParams, extraHttpRequestParams?: any): Observable<ServizioMensaPastiDipendentiDTO>;

    /**
     * Sezioni e classi configurate di una scuola del servizio mensa.
     * Ritorna le coppie distinte (classe, sezione) delle assegnazioni L3 attive del plesso origine (sezione null &#x3D; classe intera; la riga plesso-wide è esclusa). Derivazione dal CONFIGURATO del bando, non dagli studenti iscritti: una sezione senza iscritti appare. Audience ADMIN/SUPERADMIN/OP_SCUOLA/OP_COMUNE.
     * @endpoint get /api/v1/servizi/mensa/scuole/{id_scuola}/sezioni-classi
* @param requestParameters
     */
    getServizioMensaScuolaSezioniClassi(requestParameters: GetServizioMensaScuolaSezioniClassiRequestParams, extraHttpRequestParams?: any): Observable<Array<ServizioMensaSezioneClasseDTO>>;

    /**
     * Lista delle scuole del servizio mensa.
     * Ritorna le scuole materializzate del servizio header, con identità risolta dal plesso L2 origine del bando (nome, ordinamento, indirizzo, codice meccanografico) e nome dell\&#39;istituto L1 di appartenenza, numero minimo pasti da fatturare e presenza del calendario. Erede di GET /api/v1/scuola/{slugComune}/dettagli-scuole, riscopato dal comune al servizio. Audience ADMIN/SUPERADMIN/OP_SCUOLA/OP_COMUNE.
     * @endpoint get /api/v1/servizi/mensa/scuole
* @param requestParameters
     */
    listServizioMensaScuole(requestParameters: ListServizioMensaScuoleRequestParams, extraHttpRequestParams?: any): Observable<Array<ServizioMensaScuolaDTO>>;

    /**
     * Elimina una singola riga di chiusura scolastica puntuale.
     * Rimuove la riga per-giorno. La delete di una chiusura passata ripristina i giorni-mensa e ri-deriva storico/portafogli/rendicontazione della coorte matchata. Audience ADMIN/SUPERADMIN.
     * @endpoint delete /api/v1/servizi/mensa/scuole/{id_scuola}/chiusura-scolastica/{id_chiusura_scolastica}
* @param requestParameters
     */
    removeServizioMensaScuolaChiusuraScolastica(requestParameters: RemoveServizioMensaScuolaChiusuraScolasticaRequestParams, extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

    /**
     * Sostituisce i giorni ricorrenti di chiusura settimanale di una scuola.
     * Replace completo dell\&#39;insieme dei giorni (UNIQUE per giorno). Lista vuota → 400. Per ogni weekday aggiunto/rimosso le occorrenze passate nel range del calendario innescano il ricalcolo derivato su coorte scuola-intera. Erede di PUT .../giorni-della-settimana-di-chiusura. Audience ADMIN/SUPERADMIN/OP_SCUOLA/OP_COMUNE.
     * @endpoint put /api/v1/servizi/mensa/scuole/{id_scuola}/chiusure-settimanali
* @param requestParameters
     */
    replaceServizioMensaScuolaChiusureSettimanali(requestParameters: ReplaceServizioMensaScuolaChiusureSettimanaliRequestParams, extraHttpRequestParams?: any): Observable<Array<GiornoDellaSettimanaEnum>>;

    /**
     * Imposta il numero minimo di pasti da fatturare per una scuola.
     * Scrive il campo reference letto dal runtime pasti. Disponibile solo per servizi con gestione manuale attiva (400 altrimenti); valore negativo → 400; null rimuove il limite. Audience ADMIN/SUPERADMIN/OP_COMUNE.
     * @endpoint put /api/v1/servizi/mensa/scuole/{id_scuola}/numero-minimo-pasti-da-fatturare
* @param requestParameters
     */
    setServizioMensaScuolaNumeroMinimoPastiDaFatturare(requestParameters: SetServizioMensaScuolaNumeroMinimoPastiDaFatturareRequestParams, extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

    /**
     * Crea o aggiorna la configurazione pasti dipendenti di una scuola del servizio mensa.
     * Upsert con replace completo di categorie e menu non ordinari. Valida la congruenza dei totali per categoria (400 numero_pasti_incronguente). Audience ADMIN/SUPERADMIN/OP_SCUOLA/OP_COMUNE.
     * @endpoint put /api/v1/servizi/mensa/scuole/{id_scuola}/pasti-dipendenti
* @param requestParameters
     */
    setServizioMensaScuolaPastiDipendenti(requestParameters: SetServizioMensaScuolaPastiDipendentiRequestParams, extraHttpRequestParams?: any): Observable<ServizioMensaPastiDipendentiDTO>;

}
